import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from './queryKeys';
import Api from '../api/Api';
import { ICurrentUser } from '../types/api';

export function useGetCurrentUserQuery(): UseQueryResult<ICurrentUser, Error> {
  const isApiInitialized = Boolean(Api?.configData);

  return useQuery({
    queryKey: [QUERY_KEYS.user.currentUser],
    queryFn: async () => {
      const userData = await Api.currentUser.getCurrentUser();
      if (!userData) {
        throw new Error('User retrieval failed');
      }
      return userData;
    },
    enabled: isApiInitialized,
  });
}
